import EditorDashboard from "components/Dashbaord/Editor";
import AdminDashboard from "components/Dashbaord/Admin";


export const dashBoard = {
    admin: [<AdminDashboard />],
    editor: [<EditorDashboard />]
}